export const INTERVIEW_STATUS_INTERVIEW = {
    label: '面談依頼済み',
    value: 1,
};
export const INTERVIEW_STATUS_DEFINITION = {
    label: '提案確定',
    value: 2,
};
export const INTERVIEW_STATUS_DECLINE = {
    label: '見送り',
    value: 3,
};
